import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./transparencia.css";
import { pada_item, transparencia_item } from "../../json/transparenciaItem";

const Transparencia = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  const linkStyle = {
    textDecoration: 'none'
  };

  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col_12">
          <div className="transparencia_title">
            <h1>Transparencia</h1>
          </div>
        </div>
      </div>
      <div className="row">
        {transparencia_item.map((item, index) => (
          <>
            <div key={index} className="col-md-4">
              <Link  style={linkStyle} to={item.transparencia_item_url}>
                <div className="card">
                  <div className="card-body">
                    <div className="sec_transparencia">
                      <h5>{item.transparencia_item_nombre}</h5>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </>
        ))}
      </div>
      <hr className='hr-gob'/>
      <div className="row">
        <div className="col_12">
          <div className="transparencia_title">
            <h1>Programa Anual de Desarrollo Archivístico</h1>
          </div>
        </div>
      </div>
      <div className="row">
        {pada_item.map((item, index) => (
          <>
            <div key={index} className="col-md-4">
              <Link  style={linkStyle} to={item.pada_item_url}>
                <div className="card">
                  <div className="card-body">
                    <div className="sec_transparencia">
                      <h5>{item.pada_item_nombre}</h5>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </>
        ))}
      </div>
    </div>

    

    

    
  );
};

export default Transparencia;
